import { render, staticRenderFns } from "./debug_tab_hotel.vue?vue&type=template&id=4fec1a4a&"
import script from "./debug_tab_hotel.vue?vue&type=script&lang=js&"
export * from "./debug_tab_hotel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/deploy/beta-web-new/web_head/releases/20260414130119/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fec1a4a')) {
      api.createRecord('4fec1a4a', component.options)
    } else {
      api.reload('4fec1a4a', component.options)
    }
    module.hot.accept("./debug_tab_hotel.vue?vue&type=template&id=4fec1a4a&", function () {
      api.rerender('4fec1a4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/app/desktop/debug/debug_tab_hotel.vue"
export default component.exports